/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimelineExportRequest
 */
export interface TimelineExportRequest {
    /**
     * 
     * @type {object}
     * @memberof TimelineExportRequest
     */
    project: object;
    /**
     * 
     * @type {string}
     * @memberof TimelineExportRequest
     */
    sequence?: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineExportRequest
     */
    format: string;
}

export function TimelineExportRequestFromJSON(json: any): TimelineExportRequest {
    return TimelineExportRequestFromJSONTyped(json, false);
}

export function TimelineExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimelineExportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'project': json['project'],
        'sequence': !exists(json, 'sequence') ? undefined : json['sequence'],
        'format': json['format'],
    };
}

export function TimelineExportRequestToJSON(value?: TimelineExportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'project': value.project,
        'sequence': value.sequence,
        'format': value.format,
    };
}


